import React from 'react'
import style from './TopBar.module.scss'

export default function TopBar() {
    return (
        <div className={`${style.topBar}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className={`${style.left}`}>
                            <a href="mailto:info@solvix.com">
                                <i className="fa-solid fa-envelope"></i>
                                info@solvix.com
                            </a>
                            <a href="tel:+201116666028">
                                <i className="fa-solid fa-phone"></i>
                                +201116666028
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className={`${style.right}`}>
                            <a href="https://www.facebook.com/profile.php?id=61557561129171" target="_blank" rel="noopener noreferrer">
                                <i className="fa-brands fa-facebook-f"></i>
                            </a>
                            <a href="https://wa.me/201116666028" target="_blank" rel="noopener noreferrer">
                                <i className="fa-brands fa-whatsapp"></i>
                            </a>
                            <a href="tel:+201116666028">
                                <i className="fa-solid fa-phone"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
